import type {
  EntitySupplementTag,
  GetOneResponseEntitySupplementTag,
  ResponseBaseGetOneResponseEntitySupplementTag,
} from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed, unref } from "vue";
import entitySupplementService from "@/services/entitySupplement.js";

interface Args<TData = EntitySupplementTag> {
  id: Ref<string>;
  useQueryOptions?: Partial<UseQueryOptions<EntitySupplementTag, Error, TData>>;
}

export const getEntitySupplementQueryKey = (id: Ref<string>) => ["fetchGetSingleEntitySupplement", unref(id)];

export const useGetSingleEntitySupplement = <TData = EntitySupplementTag>({ id, useQueryOptions }: Args<TData>) => {
  const fetchGetSingleEntitySupplement = (): Promise<GetOneResponseEntitySupplementTag["items"]> =>
    entitySupplementService
      .getOneEntitySupplement(unref(id))
      .then((val: { data: ResponseBaseGetOneResponseEntitySupplementTag }) => val?.data?.data.items);

  return useQuery<EntitySupplementTag, Error, TData>({
    queryKey: computed(() => getEntitySupplementQueryKey(id)),
    queryFn: fetchGetSingleEntitySupplement,
    ...useQueryOptions,
  });
};
